import { useMutation, useQueryClient } from 'react-query'

import { handleApiErrors } from '../../../utils/apiErrors'
import { getEnvs } from '../../../utils/env'

export const useDownloadResultsOptimizationProcess = () => {
  const queryClient = useQueryClient()
  const { apiUrl } = getEnvs()
  return useMutation(
    [`files-data-ingestions`, `download`],
    async (optimizationProcessId: number) => {
      const response = await fetch(
        `${apiUrl}/files-data-ingestions/download/?optimization_process_id=${optimizationProcessId}`,
        {
          method: 'GET',
          credentials: 'include',
        }
      )

      if (!response.ok) {
        throw new Error(
          `Failed to download results of process ${optimizationProcessId}`
        )
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `results_${optimizationProcessId}.zip`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    {
      onError: handleApiErrors,
      onSuccess: () => {
        queryClient.invalidateQueries(['optimization-processes'])
      },
    }
  )
}
